export default __webpack_public_path__ + "static/media/rod.1aa925f5.png";